import React from 'react';
import { useSearchParams } from 'react-router-dom';

export const useTransactionId = (): string => {
  const [parameters] = useSearchParams();
  const { transactionId = '' } = React.useMemo(
    (): { readonly transactionId?: string } => Object.fromEntries(parameters.entries()),
    [parameters],
  );

  return transactionId;
};
